import {
  faCheck,
  faTimes,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Table, Button, Modal } from "react-bootstrap";
import axios from "../../../api/axios";
import useAuth from "../../../hooks/useAuth";

const TableCustom = ({ refresh, axiosData, editUser }) => {
  const [data, setData] = useState([]);
  const COMPANIES_URL = "/users/moderators";
  const DELETE_URL = "/users/moderator";
  const { auth } = useAuth();
  const [companyid, setCompanyId] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    refresh();
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  useEffect(() => {
    setData(axiosData);
  }, [axiosData]);

  const deleteUser = async (id) => {
    try {
      setShow(false);
      const response = await axios.delete(`${DELETE_URL}/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth?.accessToken,
        },
      });
      // TODO: remove console.logs before deployment
      setData(data.filter((value) => value._id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  const editValues = (e) => {
    const id = e.currentTarget.attributes.datakey.nodeValue;
    editUser({
      businessname: data[id].business[0].businessname,
      username: data[id].username,
      pwd: data[id].pwd,
      email: data[id].email,
      phone: data[id].phone,
      cuit: data[id].business[0].cuit,
      pwdValid: data[id].pwd,
      id: data[id]._id,
    });
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Acción</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Realmente desea suspender la empresa?</Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-danger" onClick={() => setShow(false)}>
            <FontAwesomeIcon icon={faTimes} />
          </Button>
          <Button
            className="btn btn-success"
            onClick={() => deleteUser(companyid)}
          >
            <FontAwesomeIcon icon={faCheck} />
          </Button>
        </Modal.Footer>
      </Modal>
      <Table striped hover size="sm" responsive>
        <thead className="table-green">
          <tr>
            <th scope="col" filterby="name">
              Empresa
            </th>
            <th scope="col" filterby="cuit">
              CUIT
            </th>
            <th scope="col" filterby="user">
              Usuario
            </th>
            <th scope="col" filterby="pass">
              Contraseña
            </th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index} style={{ cursor: "pointer" }}>
              <td datakey={index} onClick={editValues}>
                {row.business[0].businessname}
              </td>
              <td datakey={index} onClick={editValues}>
                {row.business[0].cuit}
              </td>
              <td datakey={index} onClick={editValues}>
                {row.username}
              </td>
              <td datakey={index} onClick={editValues}>
                {row.pwd}
              </td>
              <td className=" text-center" datakey="action">
                <button
                  className="btn btn-danger"
                  id={row._id}
                  onClick={(e) => {
                    setCompanyId(e.currentTarget.id);
                    setShow(true);
                  }}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {data.length === 0 && (
        <h6 className="text-center mt-3">
          No se encontraron usuarios en la base de datos
        </h6>
      )}
    </>
  );
};

export default TableCustom;
